import Cookies from 'js-cookie'
import { useContext, useEffect } from 'react'
import { classes } from 'typestyle'

import { formatDate } from '../../../share/format'
import { GLOBAL_CONTENTS } from '../../../common/global-contents'

import useBoolean from '../../../hooks/use-boolean'
import useFetch from '../../../hooks/use-fetch'
import useLocal from '../../../hooks/use-local'

import { Box } from '../../../components/box/box.component'
import { Button } from '../../../components/button'
import { RichTextView } from '../../../components/field-editor-field/view/richt-text-view'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text/text.component'

import { ml8 } from '../../../styles/styleset/margin/ml8'
import { pl8 } from '../../../styles/styleset/padding/pl8'
import { pr8 } from '../../../styles/styleset/padding/pr8'

export const Topbar = (props: any) => {
  const { context } = props
  const appLayoutContext: any = useContext(context)
  const [local] = useLocal()

  const [news, $news] = useFetch<{
    id?: string
    createdAt?: string
    body?: { title: string; body?: string }
  }>(
    { body: { title: '' } },
    {
      url: (() => {
        return `${process.env.REACT_APP_API_URL}/a/get-news`
      })(),
    },
  )

  const [isRead, $isRead] = useBoolean(false)

  const { toggle } = appLayoutContext.components.topbar || {}

  useEffect(() => {
    if (news.mounted) {
      $news.get().then((payload: any) => {
        const toggledNews = Cookies.get('aeki-news')

        if (toggledNews !== payload.id && payload.id !== undefined) {
          $isRead.set(false)
          toggle()
        }
      })
    }
  }, [news.mounted])

  return (
    <Box
      className="no-print"
      baseline="primary"
      fullHeight
      fullWidth
      alignCenterX
      alignCenterY
      flex
    >
      {!isRead && (
        <Box className={classes(pl8, pr8)} baseline="none" flex alignCenterY>
          <Text baseline="surface" semiBold>
            {news?.payload?.body?.title}
          </Text>
          {news?.payload?.body?.body && (
            <Text className={ml8} baseline="surface" semiBold link>
              <Box
                baseline="none"
                onClick={() => {
                  Modal.push({
                    componentProps: {
                      title: news?.payload?.body?.title,
                      subTitle:
                        news?.payload?.createdAt &&
                        formatDate(news?.payload?.createdAt, { time: true }),
                      componentBaseline: 'background',
                      component: <RichTextView __html={news?.payload?.body?.body} disablePadding />,
                      confirm: () => {
                        Cookies.set('aeki-news', news.payload.id || '')
                        toggle()
                        Modal.pop()
                      },
                    },
                  })
                }}
              >
                Read More
              </Box>
            </Text>
          )}
          <Button
            label={GLOBAL_CONTENTS.close[local]}
            className={ml8}
            size="xs"
            square
            onClick={() => {
              Cookies.set('aeki-news', news.payload.id || '')
              toggle()
            }}
          />
        </Box>
      )}
    </Box>
  )
}
